module.exports = __webpack_public_path__ + "static/media/thumb_template copy.0e407dec.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/utils/thumb_template copy.png
// module id = 1598
// module chunks = 0